import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

const headerBreakPoint = '720px';

const SectionMarginBottom = '100px';
const innerMarginBottom = '50px';

const borderRadius = '24px';

export const HeaderContainer = styled.section`
  position: relative;
  margin-bottom: ${SectionMarginBottom};
`;

export const DoorBackgroundSpan = styled.span`
  position: absolute;
  z-index: 0;
  display: block;
  background-color: ${colors.white};
  width: max(40%, 540px);
  height: 100%;
  border-radius: 500px 500px ${borderRadius} ${borderRadius};
  left: 50%;
  transform: translateX(-50%);
  @media (max-width: ${headerBreakPoint}) {
    width: 100%;
    transform: translateX(-100%);
  }
`;

export const HeaderContentContainer = styled.span`
  position: relative;
  display: initial;
  z-index: 2;
  width: 50vw;
  @media (max-width: ${headerBreakPoint}) {
    width: 100vw;
  }
`;

export const HeaderText = styled.h2`
  color: ${colors.fsDarkBlue};
  /* font-size: min(5vw, 4rem); */
  font-size: 6rem;
  margin-bottom: ${innerMarginBottom};
  margin-top: ${innerMarginBottom};
  text-align: center;
  @media (max-width: ${headerBreakPoint}) {
    font-size: min(12vw, 4rem);
  }
`;

export const HeaderVideoContainer = styled.span`
  display: flex;
  justify-content: center;
  margin-bottom: ${innerMarginBottom};
`;

export const HeaderIframe = styled.iframe`
  width: min(640px, 95vw);
  height: calc(min(640px, 95vw) / 1.79);
  border-radius: ${borderRadius};
`;

export const HeaderParagraphContainer = styled.span`
  display: flex;
  justify-content: center;
  flex-direction: row;
  margin-bottom: ${innerMarginBottom};
`;

export const HeaderParagraph = styled.p`
  color: ${colors.fsDarkBlue};
  font-size: 1rem;
  text-align: justify;
  width: 80%;
  font-size: 2rem;
  @media (max-width: ${headerBreakPoint}) {
    font-size: 1.2rem;
  }
`;

export const FatText = styled.b`
  color: ${colors.fsDarkBlueOffset};
`;

export const MarketingPointsContainer = styled.section`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  row-gap: 2rem;
  column-gap: 8rem;
  margin-bottom: ${SectionMarginBottom};
`;

export const MarketingPointContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 14rem;
  gap: 20px;
`;

export const MarketingPointImage = styled.img`
  width: 60%;
`;

export const MarketingPointText = styled.p`
  color: ${colors.fsDarkBlueOffset};
  font-size: 1.1rem;
  text-align: center;
  text-transform: uppercase;
`;

export const PitchAndEventVideosContainer = styled.section`
  display: flex;
  flex-direction: row;
  margin-bottom: ${SectionMarginBottom};
  column-gap: 15px;
  @media (max-width: ${headerBreakPoint}) {
    margin-top: 0px;
    flex-direction: column;
  }
`;

export const PitchAndEventVideosColumn = styled.span`
  width: 50%;
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  ${({ isColumnOne }) =>
    isColumnOne &&
    css`
      margin-top: calc(min(600px, 50vw) / (1.8 * 3));
    `};
  @media (max-width: ${headerBreakPoint}) {
    width: 100%;
    ${({ isColumnOne }) =>
      isColumnOne &&
      css`
        margin-top: 0px;
      `};
  }
`;

export const Paragraph = styled.p`
  background-color: ${colors.fsLightBlueHover};
  border-radius: ${borderRadius};
  padding: 90px 70px 90px 70px;
  margin: 0px;
  color: ${colors.fsDarkBlue};
  font-size: 1.5rem;
  @media (max-width: 900px) {
    padding: 40px 30px 40px 30px;
  }
  @media (max-width: ${headerBreakPoint}) {
    font-size: 1rem;
  }
`;

// parent container max-width: 1200px
export const EventIframe = styled.iframe`
  width: min(600px, 50vw);
  height: calc(min(600px, 50vw) / 1.8);
  border-radius: ${borderRadius};
  @media (max-width: 1200px) {
    width: 47vw;
    height: calc(47vw / 1.8);
  }
  @media (max-width: ${headerBreakPoint}) {
    width: 95vw;
    height: calc(95vw / 1.8);
  }
`;

export const TestimonialsContainer = styled.section`
  margin-bottom: ${SectionMarginBottom};
`;

export const TestimonialsHeader = styled.h3`
  color: ${colors.fsDarkBlue};
  font-size: 4rem;
  margin-bottom: 50px;
  text-align: center;
  @media (max-width: ${headerBreakPoint}) {
    font-size: min(8vw, 3rem);
  }
`;

export const TestimonialsRow = styled.span`
  display: flex;
  flex-direction: row;
  column-gap: 15px;
`;

export const TestimonialsColumn = styled.span`
  display: flex;
  flex-grow: 0;
  flex: 1 1 0px;
  flex-direction: column;
  row-gap: 15px;
`;

export const TestimonialContainer = styled.span`
  background: ${colors.fsLightBlueHover};
  border-radius: ${borderRadius};
  padding: 15px;
`;

export const TestimonialText = styled.p`
  margin: 0px;
  padding: 25px 15px 15px 15px;
`;

export const TestimonialPersonContainer = styled.span`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 15px;
`;

export const TestimonialAvatar = styled.div`
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background-image: url(${({ image }) => image || ''});
  background-size: auto 100%;
  background-position: center center;
`;

export const TestimonialNameContainer = styled.span``;

export const TextNoMargin = styled.p`
  margin: 0px;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
